import { Membership, MembershipApiResponse } from '../../../@types/membership';

export const membershipToApp = ({
  contractSource,
  valuationStatus,
  entitlements,
  realEstateProofRequestedAt,
  realEstateDamageReportRequestedAt,
}: MembershipApiResponse): Membership => ({
  contractSource,
  valuationStatus,
  entitlements,
  realEstateProofRequestedAt,
  realEstateDamageReportRequestedAt,
});
